var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "element-value",
          rawName: "v-element-value",
          value: _vm.localContent,
          expression: "localContent",
        },
      ],
      class: { "hkl-invalid-input": _vm.invalidInput },
    },
    [
      _c("Editor", {
        key: _vm.reRenderKey,
        attrs: {
          disabled: _vm.disabled,
          apiKey: "c72e8nve59b7odpled4jq6q5orbsucf4ww6fa8nhm1kifw5z",
          init: _vm.initConfig,
          plugins: _vm.pluginsOpts,
          toolbar: _vm.toolbarOpts,
        },
        model: {
          value: _vm.localContent,
          callback: function ($$v) {
            _vm.localContent = $$v
          },
          expression: "localContent",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }